// Some commentary pages moved from CT to AT on the source site. Keep the
// indexed/local CT paths unchanged; only correct links opened on that site.
export const getCurrentCCBibleStudyLink = (link) => {
  if (typeof link !== 'string' || !/^https?:\/\/(?:www\.)?ccbiblestudy\.org\//i.test(link)) {
    return link;
  }

  return link.replace(
    /(\/Old(?:%20| )Testament\/(23Isa|24Jer|26Ezek)\/)(\d{2})CT(\d{2})\.htm(?=$|[?#])/i,
    (match, path, book, number, chapter) => {
      const chapterNumber = Number(chapter);
      const maxChapter = { '23isa': 66, '24jer': 52, '26ezek': 48 }[book.toLowerCase()];
      if (chapterNumber < 1 || chapterNumber > maxChapter ||
          (book.toLowerCase() === '26ezek' && [23, 24, 25].includes(chapterNumber))) {
        return match;
      }

      return `${path}${number}AT${chapter}.htm`;
    }
  );
};
